import { render, staticRenderFns } from "./voteDetails.vue?vue&type=template&id=6cd24ad9&scoped=true&"
import script from "./voteDetails.vue?vue&type=script&lang=js&"
export * from "./voteDetails.vue?vue&type=script&lang=js&"
import style0 from "./voteDetails.vue?vue&type=style&index=0&id=6cd24ad9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd24ad9",
  null
  
)

export default component.exports